import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { RelatorioConvenioComponent } from './relatorio-convenio.component';

@NgModule({
  declarations: [RelatorioConvenioComponent],
  exports: [RelatorioConvenioComponent],
  imports: [CommonModule, PoModule]
})
export class RelatorioConvenioModule {}
